import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Button, Select, Flex } from '@chakra-ui/react';
import { getMonth, getYear } from 'date-fns';
import { useTranslation } from 'next-i18next';
import { years } from './common';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CustomHeader(_ref) {
  var date = _ref.date,
    changeYear = _ref.changeYear,
    changeMonth = _ref.changeMonth,
    decreaseMonth = _ref.decreaseMonth,
    increaseMonth = _ref.increaseMonth,
    prevMonthButtonDisabled = _ref.prevMonthButtonDisabled,
    nextMonthButtonDisabled = _ref.nextMonthButtonDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var months = t('precheckin.calendar.months').split('|');
  return _jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    gap: "sm",
    children: [_jsx(Button, _objectSpread(_objectSpread({}, navBtn), {}, {
      onClick: decreaseMonth,
      disabled: prevMonthButtonDisabled,
      className: "navigation-btn-left",
      children: _jsx("span", {
        className: "react-datepicker__navigation-icon--previous react-datepicker__navigation-icon"
      })
    })), _jsx(HeaderSelect, {
      value: months[getMonth(date)],
      onChange: value => changeMonth(months.indexOf(value)),
      options: months
    }), _jsx(HeaderSelect, {
      value: getYear(date),
      onChange: value => changeYear(+value),
      options: years
    }), _jsx(Button, _objectSpread(_objectSpread({}, navBtn), {}, {
      onClick: increaseMonth,
      disabled: nextMonthButtonDisabled,
      className: "navigation-btn-right",
      children: _jsx("span", {
        className: "react-datepicker__navigation-icon--next react-datepicker__navigation-icon"
      })
    }))]
  });
}
export default CustomHeader;
var HeaderSelect = _ref2 => {
  var value = _ref2.value,
    _onChange = _ref2.onChange,
    options = _ref2.options;
  return _jsx(Select, {
    value: value,
    onChange: _ref3 => {
      var value = _ref3.target.value;
      return _onChange(value);
    },
    size: "sm",
    width: "120px",
    children: options.map(option => _jsx("option", {
      value: option,
      children: option
    }, option))
  });
};
var navBtn = {
  type: 'button',
  variant: 'unstyled',
  size: 'xss',
  style: {
    outline: 'none',
    boxShadow: 'none'
  }
};